import { AnimatePresence, motion } from "framer-motion";

/**
 * One-time nudge shown when a swipe that started on an item panned the
 * canvas instead of moving it (see `useTouchPickup`).
 */
export function HoldHint({ show, label }: { show: boolean; label: string }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-[calc(var(--float-bottom)+4.25rem)] z-20 flex justify-center">
      <AnimatePresence>
        {show && (
          <motion.div
            role="status"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 6 }}
            transition={{ duration: 0.15 }}
            className="rounded-full bg-ink-900 px-4 py-2 text-body-sm font-medium text-white shadow-lg"
          >
            {label}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
